import { useEffect, useState } from 'react';

export const ONLINE = 'online';
export const OFFLINE = 'offline';
export const BACK_ONLINE = 'backOnline';

// How long "Back online" stays after the connection returns
export const BACK_ONLINE_MS = 3000;

/**
 * The browser's connection, for the offline banner: 'offline' while the browser has no network,
 * 'backOnline' for a few seconds after it returns, otherwise 'online'. Starts as 'online', so
 * the server render and the first browser render agree.
 */
export const useOnlineStatus = (backOnlineMs = BACK_ONLINE_MS) => {
  const [status, setStatus] = useState(ONLINE);

  useEffect(() => {
    let timer = null;
    const clearTimer = () => {
      if (timer) {
        window.clearTimeout(timer);
        timer = null;
      }
    };
    const handleOffline = () => {
      clearTimer();
      setStatus(OFFLINE);
    };
    const handleOnline = () => {
      clearTimer();
      setStatus(BACK_ONLINE);
      timer = window.setTimeout(() => {
        timer = null;
        setStatus(ONLINE);
      }, backOnlineMs);
    };

    if (window.navigator && window.navigator.onLine === false) {
      setStatus(OFFLINE);
    }
    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);
    return () => {
      clearTimer();
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    };
  }, [backOnlineMs]);

  return status;
};

export default useOnlineStatus;
